module.exports = __webpack_public_path__ + "static/media/healthy.4941ec47.svg";